import { Grid } from '@mui/material'
import React from 'react'
import demoData from '../../../demo.json'
import KpiItem from './DemoKpiItem'
import BackButton from '../../../components/BackButton'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { type RootState } from '../../../store'
import DemoGenericTable from './DemoGenericTable'

const HistoryComponent = (): JSX.Element => {
  const navigate = useNavigate()
  const kpiType = useSelector((state: RootState) => state.kpiType)
  console.log('demoData.reports', demoData.reports)
  const renderDemoHistory = (): any => {
    return demoData.reports
      .filter(r => r.history != null && r.name === kpiType)
      .map((report) => {
        return (
            <Grid style={{ marginTop: '1em' }} key={report.name} container>
                    <Grid item xs={12}>
                        <KpiItem reportData={report} history={true}/>
                    </Grid>
                <br />
            </Grid>
        )
      })
  }

  const renderTable = (): any => {
    const reportArr = demoData.reports.filter(r => r.history != null && r.name === kpiType)
    if (reportArr == null || reportArr.length === 0) {
      return
    }
    const report = reportArr[0]
    if (report.history != null && report.history.showTable === true) {
      return (
            <Grid item xs={12}>
                <DemoGenericTable/>
            </Grid>
      )
    }
  }

  return (
    <>
      <div className='link-breadcrumb'>
        <span data-testid='assetManagementbreadcrumb' onClick={ () => { navigate('/isense') }} className='assetmgmtli'>AMI Operation Hub</span>
        <span style={{ padding: '0 0.5em' }}>/</span>
        <span>{kpiType}</span>
      </div>
      <div className='topUtilityBar'>
        <BackButton/>
        <span id='componentTitle' data-testid='configurations'>{kpiType}</span>
      </div>
      <Grid container spacing={2}>
          <Grid item xs={12}>
              {renderDemoHistory()}
          </Grid>
      </Grid>
      {renderTable()}
    </>
  )
}

export default HistoryComponent
